export interface IAdyenBankAccount {
  bankAccountNumber: string | null;
  bankCity: string | null;
  bankLocationId: string | null;
  bankName: string | null;
  bic: string | null;
  countryCode: string | null;
  iban: string | null;
  ownerName: string | null;
  taxId: string | null;
}

export enum EFundingSource {
  Debit = 'Debit',
}
